import { useState } from 'react';
import { navItems } from '@/mocks/home';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 h-16 md:h-[68px] flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2.5 shrink-0">
          <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-movie-2-line text-[22px]" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-lg font-bold text-foreground-950 tracking-tight">青苹果影院</span>
            <span className="hidden sm:block text-[10px] text-foreground-500 mt-0.5">
              青春电影大全 · 片单与话题
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="px-3 py-2 text-sm font-medium text-foreground-700 rounded-md hover:text-primary-700 hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="hidden md:flex items-center gap-2 bg-background-100 border border-background-300 rounded-md pl-3 pr-1 h-10">
            <i className="ri-search-line text-foreground-500 text-base" />
            <input
              type="text"
              placeholder="搜片名 / 演员 / 关键词"
              className="w-36 lg:w-44 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-500 focus:outline-none"
            />
            <button
              type="button"
              className="h-8 px-3 rounded-md bg-secondary-500 text-background-50 text-xs font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap"
            >
              搜索
            </button>
          </div>
          <a
            href="#subscribe"
            className="hidden md:inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-bookmark-line" />
            订阅片单
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开菜单"
            className="lg:hidden w-10 h-10 rounded-md border border-background-300 text-foreground-800 flex items-center justify-center"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <div className="mx-auto max-w-[1280px] px-4 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 text-sm font-medium text-foreground-800 rounded-md hover:bg-primary-50 hover:text-primary-700 transition-colors"
              >
                {item.label}
              </a>
            ))}
            <div className="mt-2 flex items-center gap-2 bg-background-100 border border-background-300 rounded-md pl-3 pr-1 h-11">
              <i className="ri-search-line text-foreground-500 text-base" />
              <input
                type="text"
                placeholder="搜片名 / 关键词"
                className="flex-1 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-500 focus:outline-none"
              />
              <button
                type="button"
                className="h-9 px-3 rounded-md bg-secondary-500 text-background-50 text-xs font-medium whitespace-nowrap"
              >
                搜索
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}